module.exports = __webpack_public_path__ + "assets/img/hend.4e0e4e5f.png";